import { apiActionCreator, apiMultipleCalls } from '../helpers';
import { events } from '../../services/api';
import { getDayIntervals, isBefore, msToDbTime } from '../../lib/date.utils';
import { EVENTS_TIMETABLE, EVENTS_FILTER, NOTIFICATIONS_TIMETABLE } from '../../constants/actions';
import { flatten, sortBy, last } from 'lodash';
import { now } from '../../lib/date.utils';
import { nowSelector, firstNowSelector, stagesToState, zoomSelector } from '../../selectors/events/timetable';
import { liveViewSelector } from '../../selectors/events/filter';
import { ZOOM_LEVELS } from '../../constants/settings';
import { selectedDaySelector } from '../../selectors/events/timetable';
import { preferencesSelector } from '../../selectors/authentication';

function _setTimetableMode(dispatch, stages, currentIsLive) {
    const lastEntry = last(sortBy(flatten(stages.map(x => x.Performances)), x => x.endHour));
    if (lastEntry && lastEntry.endHour && !isBefore(Date.now(), lastEntry.endHour) && currentIsLive) {
        dispatch({
            type: EVENTS_FILTER.TOGGLE_ONE,
            field: 'liveView'
        });
    }
}

export function fetch(id, skipLoad = false) {
    return async (dispatch, getState) => {
        !skipLoad && dispatch({ type: EVENTS_TIMETABLE.FETCH_START });
        apiMultipleCalls(
            dispatch,
            [() => events.getTimetable(id), () => events.getPartners(id)],
            resp => {
                if (resp[0].timetable) {
                    const { event } = resp[0].timetable;
                    const { partners } = resp[1];
                    const days = getDayIntervals(event.start, event.end);
                    const currentSelected = selectedDaySelector(getState());
                    const selectedDay = skipLoad && currentSelected ? currentSelected : msToDbTime(event.start);
                    const stages = stagesToState(event.Stages || []);
                    const lastPartnerId = (preferencesSelector(getState()) || {}).lastLineupPartner;
                    try {
                        dispatch({
                            type: EVENTS_TIMETABLE.FETCH_OK,
                            days,
                            selectedDay,
                            stages,
                            partners,
                            lastPartnerId,
                            chatEnabled: !!event.chatEnabled
                        });
                        _setTimetableMode(dispatch, stages, liveViewSelector(getState()));
                    } catch (e) {
                        console.error('[Error] action/events/timetable.js - fetch');
                        console.error(e);
                    }
                }
            },
            0,
            {},
            true
        );
    };
}

export const switchDay = day => ({
    type: EVENTS_TIMETABLE.SWITCH,
    day
});

export const toNow = () => {
    return (dispatch, getState) => {
        const now = firstNowSelector(getState());
        dispatch({
            type: EVENTS_TIMETABLE.SWITCH,
            day: now ? now.date : nowSelector(getState()).day
        });
    };
};

export const updateNow = () => ({
    type: EVENTS_TIMETABLE.UPDATE,
    field: 'now',
    value: now()
});

export function zoomIn() {
    return (dispatch, getState) => {
        return _zoom(dispatch, getState, false);
    };
}
export function zoomOut() {
    return (dispatch, getState) => {
        return _zoom(dispatch, getState, true);
    };
}

function _zoom(dispatch, getState, isOut) {
    const currentZoom = zoomSelector(getState());
    const currentZoomIndex = ZOOM_LEVELS.indexOf(currentZoom);
    const newZoomIndex = isOut ? currentZoomIndex - 1 : currentZoomIndex + 1;
    let finalZoomIndex = newZoomIndex;
    if (finalZoomIndex < 0) {
        finalZoomIndex = 0;
    } else if (finalZoomIndex > ZOOM_LEVELS.length - 1) {
        finalZoomIndex = ZOOM_LEVELS.length - 1;
    }
    dispatch({
        type: EVENTS_TIMETABLE.UPDATE,
        field: 'zoom',
        value: ZOOM_LEVELS[finalZoomIndex]
    });
}

export function refreshTimetable(id) {
    return fetch(id, true);
}

export function fetchNotifications(eventId) {
    return dispatch => {
        dispatch({
            type: NOTIFICATIONS_TIMETABLE.FETCH_START
        });
        return apiActionCreator(
            dispatch,
            () => events.getNotifications(eventId),
            resp => {
                dispatch({
                    type: NOTIFICATIONS_TIMETABLE.FETCH_OK,
                    data: resp.notifications
                });
            }
        );
    };
}



// WEBPACK FOOTER //
// ./src/actions/events/timetable.js